module.exports = __webpack_public_path__ + "088494fc23a7ddf3bbbf28f3d9bda9e0.fbx";